import { createFileRoute } from '@tanstack/react-router';
import { AccountsPage } from '../components/pages/AccountsPage/AccountsPage';

export const Route = createFileRoute('/account/accounts')({
  component: AccountsPage,
});
